<script setup>
import ProspectTable from "@frontJs/components/tables/projectManagement/apikom/ProspectTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import TabGroup from "@js/components/tabs/TabGroup.vue";
import TabPanel from "@js/components/tabs/TabPanel.vue";
import PageTitle from "@js/components/titles/PageTitle.vue";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const selectedTab = ref(0);

const loading = ref(true);

const data = ref({
  all: 0,
  archived: 0,
});

function changeTab(index) {
  selectedTab.value = index;
}

function updateData() {
  loading.value = true;

  let promises = [
    fetch(route("front.projectManagement.apikom.postProspectCount"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ archived: false }),
    }),
    fetch(route("front.projectManagement.apikom.postProspectCount"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ archived: true }),
    }),
  ];

  Promise.all(promises)
    .then((responses) => {
      return Promise.all(responses.map((response) => response.json()));
    })
    .then(([allCountData, archivedCountData]) => {
      data.value.all = allCountData.count;
      data.value.archived = archivedCountData.count;
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    });
}

onMounted(() => {
  updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title>
      {{ t("title.prospects") }} - {{ t("title.apikom") }} -
      {{ t("title.projectManagement") }} - {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle>
    {{ t("title.projectManagement") }} - {{ t("title.apikom") }} -
    {{ t("title.prospects") }}
  </PageTitle>

  <LoadingSpinner v-if="loading" />

  <TabGroup
    v-else
    :selected-tab="selectedTab"
    :change-tab="changeTab"
    :tabs="{
      all: t('title.all') + ' (' + data.all + ')',
      archived: t('title.archived') + ' (' + data.archived + ')',
    }"
  >
    <template #panels>
      <TabPanel without-background unmount>
        <ProspectTable user-session-key="prospects" />
      </TabPanel>

      <TabPanel without-background unmount>
        <ProspectTable user-session-key="prospects_archived" archived />
      </TabPanel>
    </template>
  </TabGroup>
</template>
